import React from 'react';
import { getPath } from '../../utils/getPath';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const PointsValue = ({ size, classname, children }) => {
    const classes = useStyles();
    return (
        <div
            className={clsx(
                classes.points,
                classname === 'pointsNegative' && classes.pointsNegative,
                size === 'large' && classes.largeSize,
            )}
        >
            <div className={classes.value}>{children}</div>
            <div className={classes.icon}>
                <img src={getPath('public/img/flame.svg')} alt="" />
            </div>
        </div>
    );
};

const useStyles = makeStyles({
    points: {
        padding: '5px 8px 3px 10px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #34C99C',
        borderRadius: 4,
    },
    largeSize: {
        padding: '9px 9px 7px 11px',
        borderRadius: 6,
    },
    value: {
        fontSize: 14,
        fontWeight: 700,
        lineHeight: '14px',
        marginRight: 5,
        color: 'rgba(0, 0, 0, .6)',
    },
    icon: {
        display: 'flex',
        width: 11,
        height: 15,
        marginRight: 3,
    },
    pointsNegative: {
        borderColor: '#CC0514',
    },
});

export default PointsValue;
